import * as React from 'react'

import _ from 'lodash'
import moment from 'moment'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/SelectField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { get12HFormat } from 'modules/core/lib/formatTime'

import { nearestPastHalfHour } from 'modules/surveys/lib/nearestPastHalfHour'

interface Props {
  label: string
  date: string
  time: string
  readonly: boolean
  allowCropping: boolean
  onChange: (value: string) => void
}

const HOUR_IN_SECONDS = 3600
const HALF_HOUR_IN_SECONDS = HOUR_IN_SECONDS / 2

const croppedHalfHoursCount = (): number => {
  const currenNearestPastHalfHour = nearestPastHalfHour()
  const croppedHalfHoursCount =
    48 - (currenNearestPastHalfHour.hour() * 2 + currenNearestPastHalfHour.minute() / 30)
  return croppedHalfHoursCount
}

const HourPicker = ({ label, time, date, onChange, readonly, allowCropping }: Props) => {
  const { access } = useCurrentSession()
  const today = moment().format('L')
  const cropOptions = allowCropping && date === today
  const startingPoint = cropOptions ? 'hour' : 'day'
  const max = cropOptions ? croppedHalfHoursCount() : 48
  const isTimeFormat12H = access.timeFormat !== 24

  const options = _.range(0, max).map((num) => {
    const hour = moment()
      .startOf(startingPoint)
      .seconds(num * HALF_HOUR_IN_SECONDS)
      .format('HH:mm')

    return {
      label: isTimeFormat12H ? (get12HFormat(hour) as string) : hour,
      value: hour,
    }
  })

  return (
    <Select
      value={time}
      label={label}
      options={options}
      onChange={(value) => onChange(value)}
      mandatory
      readonly={!date || readonly}
    />
  )
}

export default observer(HourPicker)
